import { Observer, observer } from 'mobx-react';
import * as React from 'react';
import { Component, ComponentClass } from 'react';
import { Redirect, Route } from 'react-router';
import {AuthStore} from "../../stores/AuthStore";
import {lazyInject} from "@intelingu/core/IoC/container";

interface ProtectedRouteProps {
    exact?;
    path: string;
    redirectComponent?;
    component: ComponentClass<any>;
}

@observer export class ProtectedRoute extends Component<ProtectedRouteProps, any> {

    @lazyInject(AuthStore) authStore: AuthStore;

    render() {
        const { component: RenderComponent, redirectComponent, path, exact } = this.props;

        return <Route path={path} exact={exact} render={props => {
            return <Observer>
                { () => {
                    if (this.authStore.isAuthorized) {
                        return <RenderComponent {...props} />;
                    }

                    return <Redirect to={{
                        pathname: '/session/login'
                    }}/>;
                }}
            </Observer>
        }} />
    }

}
